/*
 * Age-verification gate (18+) — added 2026-08-18 (FINE)
 * Pairs with sections/age-gate.liquid. The inline script in that section
 * decides visibility before paint; this file wires up the buttons,
 * focus trap, scroll lock and ESC handling once the gate is visible.
 */
(function () {
  'use strict';

  var gate = document.getElementById('age-gate');
  if (!gate) return;

  // If the pre-paint script left the gate hidden, the visitor is already
  // verified — nothing to wire up.
  if (gate.hasAttribute('hidden')) return;

  var dialog = gate.querySelector('.age-gate__dialog');
  var confirmBtn = gate.querySelector('[data-age-gate-confirm]');
  var declineBtn = gate.querySelector('[data-age-gate-decline]');
  var storageKey = gate.getAttribute('data-storage-key') || 'mada_age_verified';
  var questionEls = gate.querySelectorAll('[data-age-gate-question]');
  var declinedEls = gate.querySelectorAll('[data-age-gate-declined]');
  var undoBtn = gate.querySelector('[data-age-gate-undo]');

  function focusable() {
    return Array.prototype.slice.call(
      gate.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
    );
  }

  function open() {
    document.documentElement.classList.add('age-gate-open');
    // Move focus into the dialog for keyboard/screen-reader users.
    if (confirmBtn) {
      confirmBtn.focus();
    } else if (dialog) {
      dialog.focus();
    }
    document.addEventListener('keydown', onKeydown, true);
  }

  function confirmAge() {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (e) {
      // Persistence unavailable — the gate will simply show again next visit.
    }
    close();
  }

  function close() {
    document.removeEventListener('keydown', onKeydown, true);
    document.documentElement.classList.remove('age-gate-open');
    gate.setAttribute('hidden', '');
  }

  function decline() {
    // Do NOT remember a decline. Swap the question for the dead-end message and
    // keep the overlay locked — a reload simply asks again.
    for (var i = 0; i < questionEls.length; i++) {
      questionEls[i].setAttribute('hidden', '');
    }
    for (var j = 0; j < declinedEls.length; j++) {
      declinedEls[j].removeAttribute('hidden');
    }
    if (undoBtn) {
      undoBtn.focus();
    } else if (dialog) {
      dialog.focus();
    }
  }

  function undoDecline() {
    // Mis-click recovery: restore the question so the visitor can answer again.
    for (var i = 0; i < declinedEls.length; i++) {
      declinedEls[i].setAttribute('hidden', '');
    }
    for (var j = 0; j < questionEls.length; j++) {
      questionEls[j].removeAttribute('hidden');
    }
    if (confirmBtn) {
      confirmBtn.focus();
    }
  }

  function onKeydown(event) {
    // ESC must NOT dismiss the gate — it is a hard gate. Swallow it.
    if (event.key === 'Escape' || event.keyCode === 27) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    // Trap focus within the dialog while it is open.
    if (event.key === 'Tab' || event.keyCode === 9) {
      var items = focusable();
      if (items.length === 0) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (event.shiftKey) {
        if (active === first || !gate.contains(active)) {
          event.preventDefault();
          last.focus();
        }
      } else {
        if (active === last || !gate.contains(active)) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }

  if (confirmBtn) confirmBtn.addEventListener('click', confirmAge);
  if (declineBtn) declineBtn.addEventListener('click', decline);
  if (undoBtn) undoBtn.addEventListener('click', undoDecline);

  open();
})();
